export default __webpack_public_path__ + "static/media/closed_eye_icon.acba8eb0.svg";